import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls the main content container to the top on every route change.
// Targets the .main-content div (fixed/scrollable container in App.js)
// rather than window.scrollTo, because the page uses a fixed layout.
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const container = document.querySelector('.main-content');
        if (container) {
            container.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }
    }, [pathname]);

    return null;
};

ScrollToTop.displayName = 'ScrollToTop';

export default ScrollToTop;